import React from 'react';
import { Popover as PopoverNew } from './Popover';
import { convertOldPopoverProps } from './converter.old';
import type { OldPopoverProps } from './converter.old';

export type PopoverProps = OldPopoverProps;

export const Popover = (props: PopoverProps) => <PopoverNew {...convertOldPopoverProps(props)} />;
